import React from "react";
import firsLogo from "../../lib/assets/images/firs.png";
import paystackLogo from "../../lib/assets/images/paystack.png";
import AppLayout from "../../lib/components/Layout/app-layout";
import { useQuery } from "@tanstack/react-query";
import { Divider, InputAdornment, Skeleton, TextField } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Header from "../../lib/components/Header";
import integrationService from "../../service/integrationService";
import pathnames from "../../constants/pathnames";

const integrationsLogoMap = {
  FIRS: firsLogo,
  firs: firsLogo,
  PAYSTACK: paystackLogo,
  paystack: paystackLogo,
  Paystack: paystackLogo,
  PAYSTACK_INTEGRATION: paystackLogo,
};

const getLogo = (item) => {
  if (item?.alias && integrationsLogoMap[item.alias]) return integrationsLogoMap[item.alias];
  if (item?.name && integrationsLogoMap[item.name]) return integrationsLogoMap[item.name];
  const nameLower = (item?.name || "").toLowerCase();
  const aliasLower = (item?.alias || "").toLowerCase();
  if (nameLower.includes("paystack") || aliasLower.includes("paystack")) return paystackLogo;
  if (nameLower.includes("firs") || aliasLower.includes("firs")) return firsLogo;
  return item?.logo || item?.icon || paystackLogo;
};

const Interfaces = () => {
  const [keyword, setKeyword] = React.useState("");

  const interfacesQuery = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["interfaces"],
    queryFn: () => integrationService.getInterfaces({}),
  });

  let interfaces = interfacesQuery?.data?.data?.data;
  if (keyword) {
    interfaces = interfaces?.filter((item) => {
      return item?.name?.toLowerCase().includes(keyword?.toLowerCase());
    });
  }
  return (
    <AppLayout>
      <Header title="Integrations" description="Get insights to accounts on jureb here" />
      <div className="p-3 bg-light" style={{ minHeight: "100%" }}>
        <div className="my-3"></div>
        <div className="d-flex flex-wrap justify-content-between gap-3 align-items-center mb-5">
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search integrations"
            value={keyword}
            style={{ maxWidth: 400, background: "#EEF5FC" }}
            onChange={(e) => setKeyword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <SearchOutlined />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="row">
          {interfacesQuery.isLoading && !interfaces?.length ? (
            <React.Fragment>
              {Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="col-12 col-md-4 mb-4">
                  <div className="border rounded">
                    <Skeleton variant="rect" height={200} className="mb-4" />
                    <div className="p-3">
                      <Skeleton variant="text" />
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ) : null}
          {interfaces?.map((item) => (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={item?.id}>
              <div className="border rounded bg-white">
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center gap-4 mb-4">
                    <div style={{ overflow: "hidden" }}>
                      <img
                        alt={item?.name}
                        src={getLogo(item)}
                        style={{ width: 56, height: 48, objectFit: "contain" }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="fw-medium fs-6">{item?.name}</div>
                    <div>{item?.description}</div>
                  </div>
                </div>
                <Divider className="bg-secondary" />
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <Link to={`${pathnames.INTEGRATIONS}?interface=${item?.name}`} className="text-primary text-decoration-underline">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
};

export default Interfaces;
